import {Component, Inject, Input, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {WINDOW} from '../../shared/services/window.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageUtils} from '../../utils/storage-utils';
import {UserBService} from '../ok-admin/user-b/user-b-service';
import {UserB} from '../ok-admin/user-b/user-b';
import {environment} from '../../../environments/environment';
import {ROUTES_ADMIN, ROUTES_OPER} from '../../shared/vertical-menu/vertical-menu-routes.config';

@Component({
    selector: 'validation-steps-page',
    templateUrl: './check-token-page.component.html',
    styleUrls: ['./check-token-page.component.scss'],
    providers: [

    ],
    encapsulation: ViewEncapsulation.None
})
export class CheckTokenPageComponent implements OnInit {

    constructor(@Inject(DOCUMENT) private document: Document,
                @Inject(WINDOW) private window: Window,
                private renderer: Renderer2,
                private activatedRoute: ActivatedRoute,
                private storage: StorageUtils,
                private router: Router,
                private userBService: UserBService) {

        this.activatedRoute.queryParams.subscribe(params => {
            const token = params['t'];
            storage.storeToken(token)
        });

    }

    ngOnInit(): void {
        this.renderer.removeClass(this.document.body, 'overflow-hidden');
        this.renderer.removeClass(this.document.body, 'layout-dark');
        this.renderer.removeClass(this.document.body, 'layout-transparent');

        if (this.storage.getToken() == null) {
            this.redirectToLogin()
            return
        }

        this.userBService.userBSession((resultS, userS) => {
            if (resultS.success) {
                this.saveuserData(userS)
            } else {
                this.redirectToLogin()
            }
        });
    }

    redirectToLogin() {
        this.renderer.removeClass(this.document.body, 'loadind-body');
        this.router.navigate(['/pages/login']);
    }

    saveuserData(user: UserB) {
        this.storage.storeToken(user.token)
        this.storage.storeLoggedUser(user)
        this.storage.idUser(user.id)
        this.storage.nameUser(user.name)
        this.storage.roleId(user.idRole)

        if (user.idRole === 'admin') {
            this.storage.urlHome(ROUTES_ADMIN[0].path)
            window.location.href = ROUTES_ADMIN[0].path
        }

        if (user.idRole === 'oper') {
            this.storage.urlHome(ROUTES_OPER[0].path)
            window.location.href = ROUTES_OPER[0].path
        }
    }
}
